import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/das-bewerbungsverfahren-ablauf-und-tipps.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')